import React from 'react';

function BottomLinksBar() {
  return (
    <div className="links-container">
      <a
        href="https://www.enjo.ai/tos"
        className="onboarding-bottom-link"
        target="_blank"
        rel="noopener noreferrer"
      >
        Terms of Use
      </a>
      <span className="dot">•</span>
      <a
        href="https://www.enjo.ai/security"
        className="onboarding-bottom-link"
        target="_blank"
        rel="noopener noreferrer"
      >
        Security
      </a>
      <span className="dot">•</span>
      <a
        href="https://www.enjo.ai/privacy"
        className="onboarding-bottom-link"
        target="_blank"
        rel="noopener noreferrer"
      >
        Privacy Policy
      </a>
    </div>
  );
}

export default BottomLinksBar;
